module.exports = require('./helpers/bundle-url').getBundleURL('gtHkp') + "logo-dark.eefe0b7f.svg";